import { Link } from 'react-router-dom';

// assets
import MyLogo from '../assets/MyLogo.svg';

export default function Navbar({ isOpen, setIsOpen, toggleMenu, close }) {
  const maxWidth = () => {
    return window.matchMedia('(min-width: 1024px)').matches;
  };

  const setWidth = () => {
    if (isOpen && maxWidth()) {
      setIsOpen(!isOpen);
    }
  };
  setWidth();
  window.addEventListener('resize', setWidth);

  return (
    <nav className=" relative h-28 max-w-[100vw] bg-navys-300 flex items-center z-20 px-4 shadow-2xl md:px-12 mb-10">
      <Link to="/" className="mr-auto">
        <div className="flex items-center">
          <img
            src={MyLogo}
            alt="odecoglobal logo"
            className="mr-4 w-16 md:w-20"
          />
          <h2 className="text-white text-2xl md:text-4xl font-semibold">
            ODECO
          </h2>
        </div>
      </Link>

      {/* burger-menu */}

      <div
        className=" h-fit cursor-pointer p-2 z-50 lg:hidden "
        onClick={toggleMenu}
      >
        <div
          className={`bar w-10  ${
            isOpen ? 'w-7 rotate-45 -translate-x-1 translate-y-2' : ''
          } `}
        ></div>
        <div className={`bar  w-9  ${isOpen ? 'opacity-0' : ''}`}></div>
        <div
          className={`bar w-7 ${
            isOpen ? ' -rotate-45 -translate-x-1 -translate-y-2' : ''
          } `}
        ></div>
      </div>

      <ul
        className={`fixed  top-0  right-0 w-[55%] md:w-[40%] h-full z-40 bg-navys-100 pt-28 text-white  text-xl font-medium text-center animate-slideIn ${
          isOpen ? 'block' : 'hidden'
        }   lg:flex lg:static lg:bg-transparent lg:w-fit lg:pt-0 lg:h-fit lg:animate-none  lg:transition-none  lg:transform-none lg:mr-12`}
        onClick={close}
      >
        <li className="link">
          <Link to="/">Home</Link>
        </li>
        <li className="link">
          <Link to="/about">About</Link>
        </li>
        <li className="link">
          <Link to="/projects">Projects</Link>
        </li>
      </ul>
    </nav>
  );
}
